import {
    type CheckVersionResponseType
} from "./type";
import {
    request
} from "../request";

const checkVersion = async (): Promise<CheckVersionResponseType> => {
    return await request<CheckVersionResponseType>("/staticData/checkVersion", {
        method: "GET"
    });
};
export default checkVersion;
